import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { AuthNoticeService, AuthService, Login, User, UserLoaded } from '../../../../../../../core/auth';
import { AppState } from '../../../../../../../core/reducers';
import { RoleService } from '../../../../../../management/shared/services/roleService';
import { SharedObject } from '../../../../../../management/shared/sharedObject';
import { ConfirmOtpBindingModel } from '../../../../models/confirmOtpBindingModel';

@Component({
  selector: 'app-login-pass',
  templateUrl: './login-pass.component.html',
  styleUrls: ['./login-pass.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginPassComponent implements OnInit {
  istoch = false;
  isLoading: boolean = false;
  loginWithPasswordForm: FormGroup;
  @ViewChild('mobileNumber') mobileNumberInput!: ElementRef;
  @ViewChild('password') passwordInput!: ElementRef;
  ngAfterViewInit(): void {
    // Ensure that the view is fully initialized before focusing
    setTimeout(() => {
      if (this.mobileNumberInput && this.mobileNumberInput.nativeElement)
        this.mobileNumberInput.nativeElement.focus();
    }, 0);
  }

  constructor(private fb: FormBuilder,
    private authNoticeService: AuthNoticeService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>,
    private roleService: RoleService,
    private aRoute: ActivatedRoute,
    private router: Router,
    private authOld: AuthService,

  ) { }

  redirectURL: string | null = null;


  ngOnInit() {
    this.aRoute.queryParams.subscribe(params => {
      if (params['redirectURL']) {
        this.redirectURL = params['redirectURL'];
      }
    });

    this.authNoticeService.setNotice(null);
    this.loginWithPasswordForm = this.fb.group({
      mobileNumber: [
        "",
        Validators.compose([
          Validators.required
        ])
      ],
      password: [
        "",
        Validators.compose([
          Validators.required
        ])
      ]
    });
  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.loginWithPasswordForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;

  }

  formatPhoneNumber(event: Event): void {
    this.istoch = true;
    const input = event.target as HTMLInputElement;
    let inputValue = input.value.replace(/\D/g, ''); // حذف تمامی کاراکترهای غیر عددی

    // هندل کردن هر موقع که کاربر کاراکتر فاصله وارد کند
    if (inputValue.length > 4) {
      inputValue = inputValue.slice(0, 4) + ' ' + inputValue.slice(4);
    }
    if (inputValue.length > 8) {
      inputValue = inputValue.slice(0, 8) + ' ' + inputValue.slice(8);
    }
    // بروز رسانی مقدار input
    input.value = inputValue;
  }

  optimizePhoneNumber(value: string): string {
    if (!value) return value;
    value = value.replace(/\s+/g, '');
    //if (value)
    //value = value.FaToEnDigits();
    return value;
  }

  validationPhonenumber(value: string): boolean {
    value = this.optimizePhoneNumber(value);
    if (!value) return false;
    return Boolean(value.match(SharedObject.MobilePattern));
  }

  validationPassword(value: string): boolean {
    return Boolean(value.match(SharedObject.PasswordPattern));
  }

  async loginWithPassword() {

    const authData = {
      mobile: this.optimizePhoneNumber(this.loginWithPasswordForm.controls['mobileNumber'].value),
      password: this.optimizePhoneNumber(this.loginWithPasswordForm.controls['password'].value),
    };
    this.isLoading = true;
    this.authOld
      .login(authData.mobile, authData.password)
      .pipe(
        tap(res => {
          if (res) {
            const returnUser: User = new User();
            returnUser.firstName = res["result"]["firstName"];
            returnUser.lastName = res["result"]["lastName"];
            returnUser.isMale = res["result"]["isMale"];
            returnUser.username = authData.mobile;
            returnUser.access_token = res["result"]["access_token"];
            returnUser.refresh_token = res["result"]["refresh_token"];
            returnUser.userStatus = res["result"]["userStatus"];
            returnUser.role = res["result"]["role"];
            this.store.dispatch(
              new Login({ authToken: returnUser.access_token })
            );
            this.store.dispatch(new UserLoaded({ user: returnUser }));
            this.roleService.getAllRoles();
            if (this.redirectURL) {
              this.router.navigateByUrl(this.redirectURL);
            } else
              this.router.navigateByUrl("/account/dashboard"); // Main page
          } else {
            this.isLoading = false;
            this.authNoticeService.setNotice("کاربر با این مشخصات یافت نشد", "danger");
          }
        }),
        catchError(err => {
          this.isLoading = false;
          var error = "خطای سرور";
          if (err.error.result) error = err.error.result;
          this.authNoticeService.setNotice(error, "danger");
          this.cdr.detectChanges();
          return of([]);
        }),
        finalize(() => {
          this.cdr.detectChanges();
        })
      )
      .subscribe();
  }




  backToFirst() {
    this.istoch = false;
    this.isLoading = false;
    this.cdr.markForCheck();
  }

  goLoginWithOtp() {
    this.router.navigate(['auth/login']);
  }

  showPassword: boolean = false;

  togglePasswordVisibility() {
    this.showPassword = !this.showPassword;
  }
  ressetPassword() {
    this.router.navigate(['auth/forgot-password']);
  }
}
